import ApiService from '@Utils/apiService'
import * as Path from './apiRoutes'
import { formatAmount, parseAmount, formatDate } from '@Utils/formatters'
import { cloneDeep } from 'lodash'
import moment from 'moment'
// Import the action creators
import * as Actions from './actions'
import {
  BACKGROUND_CHECK_STATUS_MAP,
} from "@Utils/constants";

export const getSurveyByID = (companyId, surveyBatch, uniqueID) => (dispatch, getState) => {
    const parameters = {
        companyid: companyId,
        surveyBatch: surveyBatch
    };
    dispatch(Actions.hasSurveyLoaded(false));
    return ApiService.get(Path.GET_SURVEY_BY_ID, parameters)
        .then(response => {
            if(response){
                dispatch(PrepareResponse(response.data));
                dispatch(Actions.loadSurveyForm(response.data));

                ApiService.get(Path.GET_SURVEY_RESPONSE_BY_ID, {surveyuniqueID: uniqueID})
                .then(surveyresponse => {
                    if(surveyresponse.data.length != 0){
                        dispatch(Actions.prepareResponseData(surveyresponse.data));
                    }
                })
            }
            return response.data;
        })
        .catch(error => {
            throw error
        })
}

export const getBackgroundcheckstatus = (id) => (dispatch, getState) => {
    return ApiService.get(Path.ROOT2 + '/' +id)
    .then(response => {
        if (response){
            return response.data;
        }
    })
}

export const getCompanyApplicant = (uniqueID) => (dispatch, getState) => {
    return ApiService.get(Path.GET_COMPANY_APPLICANT, {uniqueID: uniqueID})
        .then(response => {
            if(response){
                return response.data;
            }
        })
}

export const getExpiryDate = (uniqueID) => (dispatch, getState) => {
    return ApiService.get(Path.GET_EXPIRY + '?uniqueID=' + uniqueID)
            .then(response => {
                if(response) {
                    return response.data;
                }
            })
}

export const PrepareResponse = (data) => (dispatch, getState) => {
    const surveyResponseList = [];
    data.map((data) => {
        const surveyResponseform = {
            surveyResponseID: 0,
            surveyID: data.surveyID,
            surveyUniqueID: 0,
            response: "",
        };
        surveyResponseList.push(cloneDeep(surveyResponseform));
    });

    dispatch(Actions.prepareResponseData(surveyResponseList));
}

export const PrepareSurveyForm = (refid) => (dispatch, getState) => {
    dispatch(getCompanyApplicant(refid)).then( response => {
        dispatch(getBackgroundcheckstatus(response.applicantID)).then( res => {
        dispatch(Actions.updateSubmittedDate(res.characterReference.filter(x => x.uniqueID == refid)[0].dateSubmitted))
        dispatch(Actions.updateModifiedDate(res.characterReference.filter(x => x.uniqueID == refid)[0].dateModified))
        if (res.status === BACKGROUND_CHECK_STATUS_MAP.STATUS_PASS || res.status === BACKGROUND_CHECK_STATUS_MAP.STATUS_FAIL){
            dispatch(Actions.updateIsClosed(true));
            dispatch(Actions.hasSurveyLoaded(true));
        } else {
            dispatch(getExpiryDate(refid)).then( surveyresp => {
            let formattedExpiryDate = moment.utc(surveyresp).format("YYYY-MM-DD HH:mm");
            let currentTime = moment.utc().format("YYYY-MM-DD HH:mm");
            if (currentTime > formattedExpiryDate) {
                dispatch(Actions.updateIsClosed(true));
                dispatch(Actions.hasSurveyLoaded(true));
            } else {
                dispatch(Actions.hasSurveyLoaded(true));
            }
            });
        }
        }
    )
        dispatch(Actions.setAppID(response.applicantID));
        dispatch(getSurveyByID(response.companyID,1,refid));
    })
}

export const submitSurvey = (data) => (dispatch, getState) => {

    return ApiService.post(Path.SUBMIT_SURVEY_RESPONSE, data)
        .then(response => {
            if (response) {
                return response.data;
            }
        })
        .catch(error => {
            throw error
        })
}


export const showSurveyFormAfterSubmitModal = (data) => (dispatch, getState) => {
    setTimeout(() => {
        dispatch(Actions.showSurveyFormAfterSubmitModal(data));
        dispatch(Actions.showAlert(false));
    }, 2000);
}

export const convertToUpdateModel = (data) => {
    return {
        ...data,
        hireNeededDate: moment.utc(data.hireNeededDate).format(),
        requestDate: moment.utc(data.requestDate).format(),
        equipmentId: data.EquipmentArrayIDS.map(items => items.value),
        purposeofRequestID: data.purposeofRequestID != 1 ? data.additional : data.purposeofRequestID,
    }
}

export const convertToViewModel = (data) => {
    return {
        ...data,
        requestDate: formatDate(data.requestDate),
        hiringManagerID: data.hiringManagerID,
        jobLevelID: data.jobLevelID,
        additional: data.purposeofRequestID !== 1 ? data.purposeofRequestID : data.additional,
        purposeofRequestID: data.purposeofRequestID !== 1 ? 2 : 1,
        jobPostingStatus: data.jobPostingStatus == null ? '' : data.jobPostingStatus,
        EquipmentArrayIDS: data.listofEquipment.map((items) => ({label: items.equipmentName, value: items.equipmentID})),
        equipmentType: data.equipmentType,
    }
}